import React from 'react';
import { Button, Form, Input, Select, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const SidebarNewChannel = ({
    form,
    creatingChannel,
    channelTypeOptions,
    isEditing = false,
    isMobile,
    isDarkMode,
    themeColors,
    t,
    onBack,
    onCreate,
    canCancel = true,
}) => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        padding: isMobile ? '8px 12px 0' : 0,
        backgroundColor: isDarkMode ? themeColors.cardBackground : '#FFFFFF'
    }}>
        <Space align="center" style={{ marginBottom: 12 }}>
            {canCancel && (
                <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} />
            )}
            <Title level={5} style={{ margin: 0, color: themeColors.text }}>
                {isEditing
                    ? t('edit_virtual_channel', { defaultValue: 'Edit virtual channel' })
                    : t('create_virtual_channel', { defaultValue: 'Create virtual channel' })}
            </Title>
        </Space>
        {!canCancel && !isEditing && (
            <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                {t('create_virtual_channel_to_start_testing', { defaultValue: 'Create a virtual channel to start testing this agent.' })}
            </Text>
        )}
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingBottom: 12,
            boxSizing: 'border-box',
            paddingLeft: 5,
            paddingRight: 5,
        }}>
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label={t('channel_name')}
                    rules={[{ required: true, message: t('please_enter_channel_name', { defaultValue: 'Please enter channel name' }) }]}
                >
                    <Input placeholder={t('channel_name')} />
                </Form.Item>
                {!isEditing && (
                    <Form.Item
                        name="channel_type"
                        label={t('channel_type')}
                        rules={[{ required: true, message: t('please_select_channel_type') }]}
                    >
                        <Select
                            placeholder={t('select_channel_type')}
                            options={channelTypeOptions}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                )}
                <Form.Item
                    name="description"
                    label={t('description')}
                >
                    <Input.TextArea
                        placeholder={t('description')}
                        rows={3}
                        maxLength={240}
                        showCount
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        block
                        loading={creatingChannel}
                        onClick={onCreate}
                    >
                        {isEditing ? t('save') : t('create_channel')}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    </div>
);

export default SidebarNewChannel;
